export default __webpack_public_path__ + "static/media/appleTtsIt_It60.cc292fb2.mp3";